import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { preload } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import BlackOverlay from '../partials/black_overlay';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';

class Staff extends React.Component {
    state = {
        menu_toggled: false,
        toggle: 1,
        rooms_selected: [],
        status: config.room_status,
        sort: 'CreationDate',
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null
    }
    // Lifecycle
    componentWillMount() {
        const { id } = this.props.params;
        if (id) {
            this.props.staffs_actions && this.props.staffs_actions.fetch(id);
        }
    }
    componentWillReceiveProps = nextProps => {
        const { staffs } = nextProps;
        this.setState({ staffs });
    }
    //

    onToggle = (IdStaff) => {
        const { staffs } = this.state;
        let index = _.findIndex(staffs, r => r.IdStaff === IdStaff);
        if (index === -1) return;
        staffs[index].IsActive = !staffs[index].IsActive;
        this.props.staffs_actions && this.props.staffs_actions.toggle(IdStaff, staffs[index].IsActive);
        this.setState({ staffs });
    }
    onSort = (s) => {
        const { sort } = this.state;
        if (s === sort) this.setState({ up: !this.state.up });
        else this.setState({ up: false, sort: s });
    }
    doDelete = () => {
        const { id } = this.props.params;
        this.props.staffs_actions && this.props.staffs_actions.archive(this.state.delete_id, id);
        this.setState({ delete_id: null });
    }

    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex ">
                <i className="icon-lb_staff blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Staff</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100">
                <div className="bg-gray-2 black-input d-flex">
                    <i className="fas fa-search font-16 white align-self-center ps-3" />
                    <input className="w-100 p-3 white" type="text" placeholder="Buscar en Legendbeds" ref={(input) => this.txtSearch = input} onChange={e => this.setState({ search: e.target.value })} />
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }
    renderTH = () => {
        const { sort } = this.state;
        return <thead>
            <tr>
                <th className="bg-gray-2 white">Nombre <i className={`icon-lb_sort ${sort === 'FirstName' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('FirstName')} /></th>
                <th className="bg-gray-2 white">Contacto</th>
                <th className="bg-gray-2 white">Inicio <i className={`icon-lb_sort ${sort === 'CreationDate' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('CreationDate')} /></th>
                <th className="bg-gray-2 white">Fin</th>
                <th className="bg-gray-2 white"></th>
                <th className="bg-gray-2 white text-center">Estado</th>
                <th className="bg-gray-2 white text-right">Accion</th>
            </tr>
        </thead>
    }
    renderTable = () => {
        const { staffs, sort, up } = this.state;
        let filtered_staff = _.chain(staffs)
            .filter(r => {
                if (this.txtSearch.value) return `${r.FirstName}${r.LastName}`.toLowerCase().indexOf(this.txtSearch.value.toLowerCase()) !== -1;
                return true;
            }).value();
        return <div className="mt-4 d-flex">
            <Animated animationIn='fadeInRight' isVisible={staffs ? true : false} animationInDuration={300}
                animateOnMount={false} className="w-100 bg-gray-2 px-3 py-2 rounded d-flex">
                <table className="w-100 table m-0 poppins bg-gray-2 white">
                    {this.renderTH()}
                    {staffs && filtered_staff.length > 0 && <tbody>
                        {_.chain(filtered_staff)                            
                            .sortBy(sort)
                            .tap(arr => {
                                if (up) arr.reverse();
                            })
                            .value().map((staff, index) => <tr key={staff.IdStaff}>
                                <td className="bg-gray-2 white">
                                    <div className="d-flex">
                                        <div className="cover" style={{ width: 30, height: 30, borderRadius: 15, border: `1px solid #1771FF`, background: `url(${staff.LogoUrl}) no-repeat center center` }}></div>
                                        <div className="d-flex flex-column">
                                            <span className="ms-2 align-self-start white font-12">{`${staff.FirstName} ${staff.LastName}`}</span>
                                            <span className="ms-2 align-self-start gray font-10">{`${staff.JobTitle} | ${staff.Shift}`}</span>
                                        </div>
                                    </div>
                                </td>
                                <td className="bg-gray-2 font-10 white">
                                    <span className="blue">{staff.Email}</span><br />{`${staff.PhoneCountryCode} ${staff.Phone} - ${staff.CellphoneCountryCode} ${staff.Cellphone}`}
                                </td>
                                <td className="bg-gray-2 white">{moment(staff.CreationDate).locale('es').format('MMM Do YYYY')}</td>
                                <td className="bg-gray-2 white">-</td>
                                <td className="bg-gray-2 white font-8 text-center"><span className="w3-tag w3-blue rounded">En turno</span></td>
                                <td className="bg-gray-2 white text-center"><i onClick={() => this.onToggle(staff.IdStaff)}
                                    className={`fas fa-toggle-${staff.IsActive ? 'on green' : 'off white'} font-18`} /></td>
                                <td className="bg-gray-2 white">
                                    <div className="d-flex justify-content-end">
                                        <Link to={`/staff/edit/${staff.IdStaff}`}><i className="fas fa-edit ms-3 font-16 pointer blue" /></Link>
                                        <i className="fas fa-trash ms-3 font-16 pointer gray" onClick={() => this.setState({ delete_id: staff.IdStaff })} />
                                    </div>
                                </td>
                            </tr>)}
                    </tbody>}
                    {staffs && filtered_staff.length === 0 && <tbody>
                        <tr>
                            <td colSpan={6} className="bg-gray-2 gray-light">
                                <div className="d-flex justify-content-center" style={{ height: 200 }}>
                                    <h3 className="align-self-center gray text-center poppins">Por lo visto no tienes empleados en esta propiedad{this.state.search ? ` bajo estos parámetros de búsqueda` : ''}.<br />Haz click sobre el botón de "Nuevo empleado" para empezar.</h3>
                                </div>
                            </td>
                        </tr>
                    </tbody>}
                </table>
            </Animated>
        </div>
    }
    renderCommon = () => {
        const { id } = this.props.params;
        return (
            <div className="">
                {this.renderHeader()}
                <div className="w-100 d-flex mt-4">
                    {id && <Link to={`/staff/add/${id}`} className="btn btn-lg btn-blue white px-4 ms-2 align-self-center d-flex" >
                        Nuevo Empleado <i className="fas fa-plus-circle align-self-center font-10 ms-3" />
                    </Link>}
                </div>
                {this.renderTable()}
                <div style={{ height: 200 }} />
            </div>
        )
    }
    render() {
        const form = this.props.form_actions;
        const { rooms_selected, status } = this.state;
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>

                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small " style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    {/* MOBILE */}
                    {/*<div className="w3-container w3-hide-medium w3-hide-large">
                        <div style={{ height: 65 }} />
                        {this.renderCommon()}
        </div>*/}

                    <Menu {...this.state} {...this.props} />

                    {/* Delete Confirm */}
                    <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={this.state.delete_id ? true : false}>
                        <BlackOverlay />
                        <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                            <div className="black-input bg-gray-2 p-4 align-self-center">
                                <h3 className="white poppins text-center">Confirmar operación</h3>
                                <h6 className="blue text-center poppins">Eliminar empleado</h6>
                                <hr className="w-50 mx-auto" />
                                <h6 className="white text-center poppins">¿Está seguro de eliminar este empleado?</h6>
                                <div className="d-flex justify-content-center mt-4">
                                    <button onClick={() => this.setState({ delete_id: false })} type="button" className="btn btn-lg btn-gray-2 white ms-3 align-self-center" >
                                        <i className="fas fa-times white font-12" />
                                    </button>
                                    <button onClick={this.doDelete} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center" >
                                        <i className="fas fa-check white font-12" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Animated>
                </section>
            </Layout>
        )
    }
}

export default Staff;
